// extracted by mini-css-extract-plugin
export default {"logo":"App_logo__7Edbg","container":"App_container__Rt8T2"};